import { render, staticRenderFns } from "./ViewSupplierPage.vue?vue&type=template&id=2438cdf6"
import script from "./ViewSupplierPage.vue?vue&type=script&lang=js"
export * from "./ViewSupplierPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports